import React, { useContext, useEffect, useState } from "react";
import { Col, Image, Row } from "react-bootstrap";
import PaquetesIncluidos from "./PaquetesIncluidos";
import TotalAPagar from "./TotalAPagar";
import AvisoProductoDigital from "./AvisoProductoDigital";
import FormCodigoDescuento from "./FormCodigoDescuento";
import UserContext from "@context/User/UserContext";
import PaquetesIncluidosListItem from "./lists/items/PaquetesIncluidosListItem";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const Body = ({ precios, compraExterna, compraLectura }) => {
	// const stripePromiseLive = loadStripe("pk_live_51IE0gOFjRsT0gjxgx2Phi43JYhjKNMrsWrrUMo5Fp4lew8xWwGZtxUUscs1XPG3QtflOi8KQnlm7c4Wd9njeXUrR00qKYiy86I")
	// const stripePromiseTest = loadStripe("pk_test_51IE0gOFjRsT0gjxg9MtRKLzHSYaYxKJHiJiryN4OqfytvSexyDFBUvuf2MZfL4A3qecujZ4Os14GAlyjLD570jII00KYH97ErX")

	const { contextValue, setContextValue } = useContext(UserContext);

	const {compra} = contextValue;

	const [codigoAplicado, setCodigoAplicado] = useState(false);

	const [codigoDescuento, setCodigoDescuento] = useState("");

	const [preciosXCodigo, setPreciosXCodigo] = useState(precios?.descuentoNoAplicado);

	// const [stripePromise, setStripePromise] = useState(stripePromiseLive);

	useEffect(() => {
		// if(window.location.origin.includes('localhost') || window.location.origin.includes('qacursos')){
		// 	setStripePromise(stripePromiseTest);
		// }

		if (codigoAplicado && precios?.descuentoAplicado) {
			setContextValue({
				...contextValue,
				preciosDescuento: preciosXCodigo,
			});
		}
	}, [preciosXCodigo]);

	return (
		<>
			<Row className="detalle-compra-pricing">
				{compraLectura ? (
					<Col className="col-12 col-lg-6">
					<h3>Incluye:</h3>
					<ul id="listDetallePremium" className="fa-ul">
						
						<PaquetesIncluidosListItem 
							title="Curso completo de lectura inteligente"
						/>
						{compra.codigoConvenio ===undefined && (
							<>
								<PaquetesIncluidosListItem 
									title="Curso de regalo WordPress"
								/>
								
								<PaquetesIncluidosListItem 
									title="Curso de regalo Canva"
								/>
							</>
						)}
					</ul></Col>
				): (
					<PaquetesIncluidos compraLectura={compraLectura} codigoAplicado={codigoAplicado} />
				)}


				{compraLectura ? (
					<Col className="col-12 col-lg-6">
						<h3>Total a pagar:</h3>
						<ul>
							{compra.codigoConvenio !== '' ? (
								<li>De contado: $ {codigoAplicado ?  precios?.descuentoAplicado.lecturaVelozUveg.contado : precios?.descuentoNoAplicado.lecturaVelozUveg.contado}.00 {compraExterna ? "USD" : "MXN"}</li>
							): (
								<li>De contado: $ {precios?.descuentoAplicado.lecturaVeloz.contado}.00 {compraExterna ? "USD" : "MXN"}</li>

							)}
							{(!compraExterna && compra.codigoConvenio === '') ? (
								<>
									<li>Pago a meses sin intereses disponible</li>
									<small>Con tarjetas participantes</small>
								</>
							): null}
							
						</ul>
					</Col>
				): (
					<TotalAPagar 
						compraExterna={compraExterna}
						codigoAplicado={codigoAplicado} 
						codigoDescuento={codigoDescuento} 
						descuentoAplicado={precios?.descuentoAplicado} 
						descuentoNoAplicado={precios?.descuentoNoAplicado} 
					/>
				)}
			</Row>
			
			<Row className="detalle-compra-pricing pb-3 justify-content-center pb-lg-5 pt-5">
				
				{/* Se envian los precios con descuento para mostrarlos si tienen el codigo valido */}
				{/* <Elements stripe={stripePromise} > */}

				<FormCodigoDescuento 
					compraLectura={compraLectura}
					compraExterna={compraExterna}
					precios={precios?.descuentoAplicado} 
					states={
						{
							stateCodigoAplicado: {
								codigoAplicado,
								setCodigoAplicado,
							}, 
							stateCodigoDescuento: {
								codigoDescuento,
								setCodigoDescuento
							}, 
							statePreciosXCodigo	: {
								preciosXCodigo,
								setPreciosXCodigo,
							}
						}
					}
				/>
				{/* </Elements> */}
			</Row>

			{!compraLectura ? (
				<Row className="detalle-compra-pricing pb-4 pb-lg-5 pt-5">
					<AvisoProductoDigital />
				</Row>
			): null}
		</>
	);
};

export default Body;
